module.exports = __webpack_public_path__ + "assets/images_base/st-button-twitter-white.svg?v=e65c5ed5";